import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as config from "../config";

const reportUseUrl = (medicationId) =>
  `${config.API_URL}medications/${medicationId}/report-use`;

export const submitNeffyUseReport = createAsyncThunk(
  "SUBMIT_NEFFY_USE_REPORT",
  async ({ medicationId, ...payload }, thunkApi) => {
    try {
      const response = await axios.post(reportUseUrl(medicationId), payload);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error?.response?.data || { message: "Unable to report Neffy use." },
      );
    }
  },
);
